export var getStaticFilesURL = function getStaticFilesURL(env, path) {
  var port = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '3001';
  var ENVS = {
    development: "http://localhost:".concat(port),
    qa: 'https://static-files.public.shared.qa.noths.com/webapps/shared',
    production: 'https://static-files.notonthehighstreet.com/webapps/shared'
  };
  return "".concat(ENVS[env], "/").concat(path);
};